/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * SoftwareApi - axios parameter creator
 */
export const SoftwareApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddIdentifierToFileViewModel} [addIdentifierToFileViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifierToFile: async (authorization, authVersion, addIdentifierToFileViewModel, options = {}) => {
            const localVarPath = `/v1/Software/AddIdentifierToFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(addIdentifierToFileViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary creates a software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {AddSoftwareResourceViewModel} [addSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addSoftwareResource: async (authorization, authVersion, companyView, addSoftwareResourceViewModel, options = {}) => {
            const localVarPath = `/v1/Software/AddSoftwareResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(addSoftwareResourceViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesViewModel} [addSoftwareResourceToDevicesViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareResourceToDevices: async (authorization, authVersion, addSoftwareResourceToDevicesViewModel, options = {}) => {
            const localVarPath = `/v1/Software/AddSoftwareResourceToDevices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(addSoftwareResourceToDevicesViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices based on OS
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesFromOsViewModel} [addSoftwareResourceToDevicesFromOsViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareResourceToDevicesOfOsType: async (authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options = {}) => {
            const localVarPath = `/v1/Software/AddSoftwareResourceToDevicesOfOsType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(addSoftwareResourceToDevicesFromOsViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CreateSoftwareResourceWithTypeAsStringViewModel} [createSoftwareResourceWithTypeAsStringViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addSoftwareResourceV2: async (authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options = {}) => {
            const localVarPath = `/v1/Software/AddSoftwareResourceV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createSoftwareResourceWithTypeAsStringViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary change file identifier
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {FileIdentifierViewModel} [fileIdentifierViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFileIdentifier: async (authorization, authVersion, fileIdentifierViewModel, options = {}) => {
            const localVarPath = `/v1/Software/ChangeFileIdentifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fileIdentifierViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createSoftwareVersionAnswer: async (softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options = {}) => {
            const localVarPath = `/v1/Software/CreateSoftwareVersionAnswer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareResourceId !== undefined) {
                localVarQueryParameter['SoftwareResourceId'] = softwareResourceId;
            }
            if (version !== undefined) {
                localVarFormParams.append('Version', version);
            }
            if (description !== undefined) {
                localVarFormParams.append('Description', description);
            }
            if (changeLogs !== undefined) {
                localVarFormParams.append('ChangeLogs', changeLogs);
            }
            if (keyValueJson !== undefined) {
                localVarFormParams.append('KeyValueJson', keyValueJson);
            }
            if (keyValueIdentifier !== undefined) {
                localVarFormParams.append('KeyValueIdentifier', keyValueIdentifier);
            }
            if (fileIdentifiers !== undefined) {
                localVarFormParams.append('FileIdentifiers', fileIdentifiers);
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element);
                });
            }
            if (recommended !== undefined) {
                localVarFormParams.append('recommended', String(recommended));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {number} [oldVersionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [oldFiles]
         * @param {string} [oldFileIdentifiers]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionBasedOnOlderVersion: async (softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options = {}) => {
            const localVarPath = `/v1/Software/CreateVersionBasedOnOlderVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareResourceId !== undefined) {
                localVarQueryParameter['SoftwareResourceId'] = softwareResourceId;
            }
            if (oldVersionId !== undefined) {
                localVarQueryParameter['OldVersionId'] = oldVersionId;
            }
            if (version !== undefined) {
                localVarFormParams.append('Version', version);
            }
            if (description !== undefined) {
                localVarFormParams.append('Description', description);
            }
            if (changeLogs !== undefined) {
                localVarFormParams.append('ChangeLogs', changeLogs);
            }
            if (keyValueJson !== undefined) {
                localVarFormParams.append('KeyValueJson', keyValueJson);
            }
            if (keyValueIdentifier !== undefined) {
                localVarFormParams.append('KeyValueIdentifier', keyValueIdentifier);
            }
            if (oldFiles !== undefined) {
                localVarFormParams.append('OldFiles', oldFiles);
            }
            if (oldFileIdentifiers !== undefined) {
                localVarFormParams.append('OldFileIdentifiers', oldFileIdentifiers);
            }
            if (fileIdentifiers !== undefined) {
                localVarFormParams.append('FileIdentifiers', fileIdentifiers);
            }
            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('Files', element);
                });
            }
            if (recommended !== undefined) {
                localVarFormParams.append('recommended', String(recommended));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteSoftwareResource: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/DeleteSoftwareResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource device link and all its version links
         * @param {number} [softwareResourceId]
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareResourceFromDevice: async (softwareResourceId, deviceId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/DeleteSoftwareResourceFromDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareResourceId !== undefined) {
                localVarQueryParameter['softwareResourceId'] = softwareResourceId;
            }
            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software version (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteSoftwareVersion: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/DeleteSoftwareVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editResourceVersionChangeLogMarkdown: async (authorization, authVersion, companyView, markdownViewModel, options = {}) => {
            const localVarPath = `/v1/Software/EditResourceVersionChangeLogMarkdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(markdownViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editResourceVersionMarkdown: async (authorization, authVersion, companyView, markdownViewModel, options = {}) => {
            const localVarPath = `/v1/Software/EditResourceVersionMarkdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(markdownViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary edit software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {EditSoftwareResourceViewModel} [editSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        editSoftwareResource: async (authorization, authVersion, companyView, editSoftwareResourceViewModel, options = {}) => {
            const localVarPath = `/v1/Software/EditSoftwareResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(editSoftwareResourceViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit softwareResource markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftwareResourceMarkdown: async (authorization, authVersion, companyView, markdownViewModel, options = {}) => {
            const localVarPath = `/v1/Software/EditSoftwareResourceMarkdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(markdownViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the SoftwareResourceId and the versionId of the latest version of the artifact bundle installed on the device with the given activationUid
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtifactByActivationUid: async (activationUid, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'activationUid' is not null or undefined
            assertParamExists('getArtifactByActivationUid', 'activationUid', activationUid);
            const localVarPath = `/v1/Software/GetArtifactByActivationUid/{activationUid}`
                .replace(`{${"activationUid"}}`, encodeURIComponent(String(activationUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns artifact bundle to copy
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtifactVersionForCopy: async (versionId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetArtifactVersionForCopy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (versionId !== undefined) {
                localVarQueryParameter['versionId'] = versionId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesWithSoftwareResource: async (softwareResourceId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetDevicesWithSoftwareResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareResourceId !== undefined) {
                localVarQueryParameter['softwareResourceId'] = softwareResourceId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallableSoftwareResources: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetInstallableSoftwareResources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given device
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryByDeviceId: async (deviceId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetInstallationHistoryByDeviceId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given softwareresource
         * @param {number} [swrId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryBySoftwareResourceId: async (swrId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetInstallationHistoryBySoftwareResourceId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (swrId !== undefined) {
                localVarQueryParameter['swrId'] = swrId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given version
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryByVersionId: async (versionId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetInstallationHistoryByVersionId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (versionId !== undefined) {
                localVarQueryParameter['versionId'] = versionId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestVersionOfArtifactForLogger: async (activationUid, authorization, authVersion, companyView, options = {}) => {
            // verify required parameter 'activationUid' is not null or undefined
            assertParamExists('getLatestVersionOfArtifactForLogger', 'activationUid', activationUid);
            const localVarPath = `/v1/Software/GetLatestVersionOfArtifactForLogger/{activationUid}`
                .replace(`{${"activationUid"}}`, encodeURIComponent(String(activationUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  software resource and all its versions based on a resource id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceByVersionId: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourceByVersionId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  the softwareResourceId by name
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceId: async (softwareResource, company, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourceId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (softwareResource !== undefined) {
                localVarQueryParameter['softwareResource'] = softwareResource;
            }
            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns SoftwareResourceTypes
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceTypes: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [companyId]
         * @param {number} [typeId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesByType: async (companyId, typeId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourcesByType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            if (typeId !== undefined) {
                localVarQueryParameter['TypeId'] = typeId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {number} [fleetId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesForFleet: async (fleetId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourcesForFleet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (fleetId !== undefined) {
                localVarQueryParameter['fleetId'] = fleetId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [projectId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesForProject: async (projectId, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/GetSoftwareResourcesForProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/json
         * @summary dual
         * @param {string} [version]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {DualPostViewModel} [dualPostViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logApplicationStarted: async (version, authorization, authVersion, dualPostViewModel, options = {}) => {
            const localVarPath = `/v1/Software/LogApplicationStarted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (version != null) {
                localVarHeaderParameter['Version'] = String(version);
            }
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(dualPostViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceDetail: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/ResourceDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all available resources (n)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareResourcesOverview: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/SoftwareResourcesOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  true if the given combination of version, softwareresouce and company exists
         * @param {string} [version]
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareVersionCheckByName: async (version, softwareResource, company, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/Software/SoftwareVersionCheckByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            if (softwareResource !== undefined) {
                localVarQueryParameter['softwareResource'] = softwareResource;
            }
            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SoftwareApi - functional programming interface
 */
export const SoftwareApiFp = function (configuration) {
    const localVarAxiosParamCreator = SoftwareApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddIdentifierToFileViewModel} [addIdentifierToFileViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.addIdentifierToFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary creates a software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {AddSoftwareResourceViewModel} [addSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.addSoftwareResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesViewModel} [addSoftwareResourceToDevicesViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.addSoftwareResourceToDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices based on OS
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesFromOsViewModel} [addSoftwareResourceToDevicesFromOsViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.addSoftwareResourceToDevicesOfOsType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CreateSoftwareResourceWithTypeAsStringViewModel} [createSoftwareResourceWithTypeAsStringViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.addSoftwareResourceV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary change file identifier
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {FileIdentifierViewModel} [fileIdentifierViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.changeFileIdentifier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.createSoftwareVersionAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {number} [oldVersionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [oldFiles]
         * @param {string} [oldFileIdentifiers]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.createVersionBasedOnOlderVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteSoftwareResource(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftwareResource(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.deleteSoftwareResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource device link and all its version links
         * @param {number} [softwareResourceId]
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.deleteSoftwareResourceFromDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software version (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteSoftwareVersion(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftwareVersion(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.deleteSoftwareVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.editResourceVersionChangeLogMarkdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.editResourceVersionMarkdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary edit software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {EditSoftwareResourceViewModel} [editSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.editSoftwareResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit softwareResource markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.editSoftwareResourceMarkdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the SoftwareResourceId and the versionId of the latest version of the artifact bundle installed on the device with the given activationUid
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getArtifactByActivationUid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns artifact bundle to copy
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getArtifactVersionForCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getDevicesWithSoftwareResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstallableSoftwareResources(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstallableSoftwareResources(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getInstallableSoftwareResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given device
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getInstallationHistoryByDeviceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given softwareresource
         * @param {number} [swrId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getInstallationHistoryBySoftwareResourceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given version
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getInstallationHistoryByVersionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getLatestVersionOfArtifactForLogger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  software resource and all its versions based on a resource id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourceByVersionId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  the softwareResourceId by name
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns SoftwareResourceTypes
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourceTypes(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourceTypes(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [companyId]
         * @param {number} [typeId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourcesByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {number} [fleetId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourcesForFleet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [projectId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.getSoftwareResourcesForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/json
         * @summary dual
         * @param {string} [version]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {DualPostViewModel} [dualPostViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.logApplicationStarted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resourceDetail(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resourceDetail(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.resourceDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all available resources (n)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softwareResourcesOverview(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softwareResourcesOverview(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.softwareResourcesOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  true if the given combination of version, softwareresouce and company exists
         * @param {string} [version]
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SoftwareApi.softwareVersionCheckByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SoftwareApi - factory interface
 */
export const SoftwareApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SoftwareApiFp(configuration);
    return {
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddIdentifierToFileViewModel} [addIdentifierToFileViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options) {
            return localVarFp.addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary creates a software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {AddSoftwareResourceViewModel} [addSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options) {
            return localVarFp.addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesViewModel} [addSoftwareResourceToDevicesViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options) {
            return localVarFp.addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Adds a software resource and all its versions to a list of devices based on OS
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {AddSoftwareResourceToDevicesFromOsViewModel} [addSoftwareResourceToDevicesFromOsViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options) {
            return localVarFp.addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {CreateSoftwareResourceWithTypeAsStringViewModel} [createSoftwareResourceWithTypeAsStringViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options) {
            return localVarFp.addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary change file identifier
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {FileIdentifierViewModel} [fileIdentifierViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options) {
            return localVarFp.changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options) {
            return localVarFp.createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [softwareResourceId]
         * @param {number} [oldVersionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {string} [version]
         * @param {string} [description]
         * @param {string} [changeLogs]
         * @param {string} [keyValueJson]
         * @param {string} [keyValueIdentifier]
         * @param {string} [oldFiles]
         * @param {string} [oldFileIdentifiers]
         * @param {string} [fileIdentifiers]
         * @param {Array<File>} [files]
         * @param {boolean} [recommended]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options) {
            return localVarFp.createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteSoftwareResource(id, authorization, authVersion, companyView, options) {
            return localVarFp.deleteSoftwareResource(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software resource device link and all its version links
         * @param {number} [softwareResourceId]
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options) {
            return localVarFp.deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a software version (ADMIN)
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteSoftwareVersion(id, authorization, authVersion, companyView, options) {
            return localVarFp.deleteSoftwareVersion(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            return localVarFp.editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit resourceVersion readme markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            return localVarFp.editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary edit software resource
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {EditSoftwareResourceViewModel} [editSoftwareResourceViewModel]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options) {
            return localVarFp.editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit softwareResource markdown
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {MarkdownViewModel} [markdownViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
            return localVarFp.editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the SoftwareResourceId and the versionId of the latest version of the artifact bundle installed on the device with the given activationUid
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options) {
            return localVarFp.getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns artifact bundle to copy
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options) {
            return localVarFp.getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [softwareResourceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options) {
            return localVarFp.getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallableSoftwareResources(authorization, authVersion, companyView, options) {
            return localVarFp.getInstallableSoftwareResources(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given device
         * @param {number} [deviceId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options) {
            return localVarFp.getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given softwareresource
         * @param {number} [swrId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options) {
            return localVarFp.getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installation hystory for a given version
         * @param {number} [versionId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options) {
            return localVarFp.getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} activationUid
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options) {
            return localVarFp.getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  software resource and all its versions based on a resource id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  the softwareResourceId by name
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns SoftwareResourceTypes
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourceTypes(authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourceTypes(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [companyId]
         * @param {number} [typeId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources
         * @param {number} [fleetId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  installable Software resources for projects
         * @param {number} [projectId]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options) {
            return localVarFp.getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/json
         * @summary dual
         * @param {string} [version]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {DualPostViewModel} [dualPostViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options) {
            return localVarFp.logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns resource details
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resourceDetail(id, authorization, authVersion, companyView, options) {
            return localVarFp.resourceDetail(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all available resources (n)
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareResourcesOverview(authorization, authVersion, companyView, options) {
            return localVarFp.softwareResourcesOverview(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns  true if the given combination of version, softwareresouce and company exists
         * @param {string} [version]
         * @param {string} [softwareResource]
         * @param {string} [company]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options) {
            return localVarFp.softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SoftwareApi - object-oriented interface
 */
export class SoftwareApi extends BaseAPI {
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {AddIdentifierToFileViewModel} [addIdentifierToFileViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options) {
        return SoftwareApiFp(this.configuration).addIdentifierToFile(authorization, authVersion, addIdentifierToFileViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary creates a software resource
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {AddSoftwareResourceViewModel} [addSoftwareResourceViewModel]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options) {
        return SoftwareApiFp(this.configuration).addSoftwareResource(authorization, authVersion, companyView, addSoftwareResourceViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Adds a software resource and all its versions to a list of devices
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {AddSoftwareResourceToDevicesViewModel} [addSoftwareResourceToDevicesViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options) {
        return SoftwareApiFp(this.configuration).addSoftwareResourceToDevices(authorization, authVersion, addSoftwareResourceToDevicesViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Adds a software resource and all its versions to a list of devices based on OS
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {AddSoftwareResourceToDevicesFromOsViewModel} [addSoftwareResourceToDevicesFromOsViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options) {
        return SoftwareApiFp(this.configuration).addSoftwareResourceToDevicesOfOsType(authorization, authVersion, addSoftwareResourceToDevicesFromOsViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {CreateSoftwareResourceWithTypeAsStringViewModel} [createSoftwareResourceWithTypeAsStringViewModel]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options) {
        return SoftwareApiFp(this.configuration).addSoftwareResourceV2(authorization, authVersion, companyView, createSoftwareResourceWithTypeAsStringViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary change file identifier
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {FileIdentifierViewModel} [fileIdentifierViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options) {
        return SoftwareApiFp(this.configuration).changeFileIdentifier(authorization, authVersion, fileIdentifierViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [softwareResourceId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {string} [version]
     * @param {string} [description]
     * @param {string} [changeLogs]
     * @param {string} [keyValueJson]
     * @param {string} [keyValueIdentifier]
     * @param {string} [fileIdentifiers]
     * @param {Array<File>} [files]
     * @param {boolean} [recommended]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options) {
        return SoftwareApiFp(this.configuration).createSoftwareVersionAnswer(softwareResourceId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, fileIdentifiers, files, recommended, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [softwareResourceId]
     * @param {number} [oldVersionId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {string} [version]
     * @param {string} [description]
     * @param {string} [changeLogs]
     * @param {string} [keyValueJson]
     * @param {string} [keyValueIdentifier]
     * @param {string} [oldFiles]
     * @param {string} [oldFileIdentifiers]
     * @param {string} [fileIdentifiers]
     * @param {Array<File>} [files]
     * @param {boolean} [recommended]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options) {
        return SoftwareApiFp(this.configuration).createVersionBasedOnOlderVersion(softwareResourceId, oldVersionId, authorization, authVersion, companyView, version, description, changeLogs, keyValueJson, keyValueIdentifier, oldFiles, oldFileIdentifiers, fileIdentifiers, files, recommended, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a software resource (ADMIN)
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    deleteSoftwareResource(id, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).deleteSoftwareResource(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a software resource device link and all its version links
     * @param {number} [softwareResourceId]
     * @param {number} [deviceId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).deleteSoftwareResourceFromDevice(softwareResourceId, deviceId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a software version (ADMIN)
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    deleteSoftwareVersion(id, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).deleteSoftwareVersion(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit resourceVersion readme markdown
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {MarkdownViewModel} [markdownViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
        return SoftwareApiFp(this.configuration).editResourceVersionChangeLogMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit resourceVersion readme markdown
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {MarkdownViewModel} [markdownViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
        return SoftwareApiFp(this.configuration).editResourceVersionMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary edit software resource
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {EditSoftwareResourceViewModel} [editSoftwareResourceViewModel]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options) {
        return SoftwareApiFp(this.configuration).editSoftwareResource(authorization, authVersion, companyView, editSoftwareResourceViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit softwareResource markdown
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {MarkdownViewModel} [markdownViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options) {
        return SoftwareApiFp(this.configuration).editSoftwareResourceMarkdown(authorization, authVersion, companyView, markdownViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the SoftwareResourceId and the versionId of the latest version of the artifact bundle installed on the device with the given activationUid
     * @param {string} activationUid
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getArtifactByActivationUid(activationUid, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns artifact bundle to copy
     * @param {number} [versionId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getArtifactVersionForCopy(versionId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installable Software resources for projects
     * @param {number} [softwareResourceId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getDevicesWithSoftwareResource(softwareResourceId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installable Software resources
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstallableSoftwareResources(authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getInstallableSoftwareResources(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installation hystory for a given device
     * @param {number} [deviceId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getInstallationHistoryByDeviceId(deviceId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installation hystory for a given softwareresource
     * @param {number} [swrId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getInstallationHistoryBySoftwareResourceId(swrId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installation hystory for a given version
     * @param {number} [versionId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getInstallationHistoryByVersionId(versionId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} activationUid
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getLatestVersionOfArtifactForLogger(activationUid, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  software resource and all its versions based on a resource id
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourceByVersionId(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  the softwareResourceId by name
     * @param {string} [softwareResource]
     * @param {string} [company]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourceId(softwareResource, company, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns SoftwareResourceTypes
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourceTypes(authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourceTypes(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns resource details
     * @param {number} [companyId]
     * @param {number} [typeId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourcesByType(companyId, typeId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installable Software resources
     * @param {number} [fleetId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourcesForFleet(fleetId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  installable Software resources for projects
     * @param {number} [projectId]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).getSoftwareResourcesForProject(projectId, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/json
     * @summary dual
     * @param {string} [version]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {DualPostViewModel} [dualPostViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options) {
        return SoftwareApiFp(this.configuration).logApplicationStarted(version, authorization, authVersion, dualPostViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns resource details
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resourceDetail(id, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).resourceDetail(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all available resources (n)
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    softwareResourcesOverview(authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).softwareResourcesOverview(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns  true if the given combination of version, softwareresouce and company exists
     * @param {string} [version]
     * @param {string} [softwareResource]
     * @param {string} [company]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options) {
        return SoftwareApiFp(this.configuration).softwareVersionCheckByName(version, softwareResource, company, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
}
